export const getIds = (data = []) => {
  const parentCodes = data.map((item) => item.typeGroup.trim())
  return [...new Set(parentCodes)]
}

export const getDataTable = (
  ids = [],
  dataDefault = [],
  dataComparing = [],
  isComparingExist = false,
  defaultVsicId = null,
  comparingVsicId = null,
) => {
  const calcPercent = (data, type = 'count') => {
    if (!data.length || !data[0] || typeof data[0][type] === 'undefined') {
      return data.map((item) => ({ ...item, percent: undefined }))
    }
    const total = data.reduce((sum, item) => sum + (item.count || 0), 0)
    return data.map((item) => ({
      ...item,
      percent: total ? (item.count || 0) / total : 0,
    }))
  }

  const defaultWithPercent = calcPercent(dataDefault)
  const comparingWithPercent = calcPercent(dataComparing)
  const dataTable = {}
  ids.forEach((id) => {
    dataTable[id] =
      dataComparing.length || isComparingExist
        ? [
            defaultWithPercent.find((item) => item.typeGroup === id) || {
              vsicId: defaultVsicId,
            },
            comparingWithPercent.find((item) => item.typeGroup === id) || {
              vsicId: comparingVsicId,
            },
          ]
        : [
            defaultWithPercent.find((item) => item.typeGroup === id) || {
              vsicId: defaultVsicId,
            },
          ]
  })
  return dataTable
}
